import { PostJobPageFormStateEntryAjax } from './post-job-page-form-state.backend-model';
import { PostJobPageFormState } from './post-job-page-form-state.model';

export function transformPostJobPageFormState(
  state: PostJobPageFormStateEntryAjax,
): PostJobPageFormState {
  return {
    communitySelection: state.communitySelection,
    contestDuration: state.contestDuration || null,
    contestDurationType: state.contestDurationType || null,
    contestPrize: state.contestPrize || null,
    contestType: state.contestType || null,
    contestUpgrades: state.contestUpgrades || null,
    currencyId: state.currencyId || null,
    description: state.description,
    id: state.id,
    isLocal: state.isLocal || null,
    jobType: state.jobType || null,
    projectBudgetRange: state.projectBudgetRange || null,
    projectBudgetType: state.projectBudgetType || null,
    projectUpgrades: state.projectUpgrades || null,
    projectType: state.projectType || null,
    skills: state.skills || null,
    submitDate: state.submitDate * 1000,
    templateSelection: state.templateSelection,
    title: state.title || state.project_name || '',
    userId: state.userId,
  };
}
